var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFyndricon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6242 36.7477C12.6242 38.4342 11.257 39.8014 9.57049 39.8014C7.88396 39.8014 6.51678 38.4342 6.51678 36.7477C6.51678 35.0612 7.88396 33.694 9.57049 33.694C11.257 33.694 12.6242 35.0612 12.6242 36.7477Z",
    stroke: "url(#paint0_linear_6663_26985)",
    strokeWidth: 1.90855
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4211 36.7477C22.4211 38.4342 21.0539 39.8014 19.3674 39.8014C17.6808 39.8014 16.3137 38.4342 16.3137 36.7477C16.3137 35.0612 17.6808 33.694 19.3674 33.694C21.0539 33.694 22.4211 35.0612 22.4211 36.7477Z",
    stroke: "url(#paint1_linear_6663_26985)",
    strokeWidth: 1.90855
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1105 36.7477C33.1105 38.4342 31.7433 39.8014 30.0568 39.8014C28.3703 39.8014 27.0031 38.4342 27.0031 36.7477C27.0031 35.0612 28.3703 33.694 30.0568 33.694C31.7433 33.694 33.1105 35.0612 33.1105 36.7477Z",
    stroke: "url(#paint2_linear_6663_26985)",
    strokeWidth: 1.90855
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9074 36.7477C42.9074 38.4342 41.5402 39.8014 39.8537 39.8014C38.1672 39.8014 36.8 38.4342 36.8 36.7477C36.8 35.0612 38.1672 33.694 39.8537 33.694C41.5402 33.694 42.9074 35.0612 42.9074 36.7477Z",
    stroke: "url(#paint3_linear_6663_26985)",
    strokeWidth: 1.90855
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5949 36.7477C53.5949 38.4342 52.2277 39.8014 50.5412 39.8014C48.8547 39.8014 47.4875 38.4342 47.4875 36.7477C47.4875 35.0612 48.8547 33.694 50.5412 33.694C52.2277 33.694 53.5949 35.0612 53.5949 36.7477Z",
    stroke: "url(#paint4_linear_6663_26985)",
    strokeWidth: 1.90855
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.125 17.2505C41.125 24.1019 35.5708 29.6561 28.7193 29.6561C21.8679 29.6561 16.3137 24.1019 16.3137 17.2505C16.3137 10.3991 21.8679 4.8449 28.7193 4.8449C35.5708 4.8449 41.125 10.3991 41.125 17.2505Z",
    stroke: "url(#paint5_linear_6663_26985)",
    strokeWidth: 1.90855
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8901 17.2503C34.8901 20.6584 32.1272 23.4213 28.7191 23.4213C25.3109 23.4213 22.548 20.6584 22.548 17.2503C22.548 13.8421 25.3109 11.0793 28.7191 11.0793C32.1272 11.0793 34.8901 13.8421 34.8901 17.2503Z",
    stroke: "url(#paint6_linear_6663_26985)",
    strokeWidth: 1.90855
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4385 16.8258C30.4385 17.7744 29.6695 18.5435 28.7208 18.5435C27.7721 18.5435 27.0031 17.7744 27.0031 16.8258C27.0031 15.8771 27.7721 15.1081 28.7208 15.1081C29.6695 15.1081 30.4385 15.8771 30.4385 16.8258Z",
    stroke: "url(#paint7_linear_6663_26985)",
    strokeWidth: 1.90855
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.119 9.31687L27.1116 15.9316C27.011 16.0423 26.9069 16.2184 26.9011 16.4495C26.8952 16.6848 26.9935 16.8719 27.1005 16.9942C27.2638 17.1807 27.7977 17.7784 28.1647 18.1884L28.687 17.7209L28.1647 18.1884C28.5267 18.593 29.1583 18.5895 29.5171 18.1863L35.4044 11.5716H37.1183C37.3822 11.5716 37.633 11.4567 37.8052 11.2567L37.2629 10.7896L37.8052 11.2567L41.2222 7.2896C41.7283 6.70198 41.3108 5.79141 40.5353 5.79141H38.421V3.48946C38.421 2.6634 37.4063 2.26775 36.8472 2.87577L33.3583 6.66927C33.2044 6.83659 33.119 7.05563 33.119 7.28296V9.31687ZM40.1371 6.35608C40.1373 6.35587 40.1374 6.35565 40.1376 6.35544L40.1371 6.35608ZM37.9007 3.84475L37.7053 3.66499L37.9007 3.84475C37.9006 3.8449 37.9004 3.84506 37.9003 3.84521L37.9007 3.84475Z",
    fill: "#1D1A36",
    stroke: "url(#paint8_linear_6663_26985)",
    strokeWidth: 1.43141,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40592 42.4755L2.40592 42.4755L2.71003 42.137C2.94613 41.8742 3.22419 41.6524 3.53288 41.4806C4.00796 41.2162 4.54266 41.0775 5.08635 41.0775H12.9841C13.5641 41.0775 14.1396 41.1808 14.6834 41.3825L14.9132 41.4678C15.2372 41.588 15.5426 41.7536 15.8202 41.9596L15.2549 42.7213L15.8202 41.9596L15.9452 42.0523L2.40592 42.4755ZM2.40592 42.4755C2.17825 42.7289 1.97548 43.0037 1.80043 43.2959L1.65889 43.5322C1.25764 44.2022 1.04572 44.9684 1.04572 45.7493V56.2463C1.04572 56.8788 1.55842 57.3915 2.19086 57.3915H3.89661C4.21659 57.3915 4.50592 57.2602 4.7137 57.0486M2.40592 42.4755L4.7137 57.0486M4.7137 57.0486C4.92149 57.2602 5.21082 57.3915 5.5308 57.3915H13.4989C13.8189 57.3915 14.1083 57.2602 14.316 57.0486C14.5238 57.2602 14.8132 57.3915 15.1331 57.3915H16.9266C17.5106 57.3915 17.984 56.9181 17.984 56.3341V46.3034C17.984 45.497 17.8132 44.6998 17.4827 43.9642C17.1421 43.2059 16.6128 42.5477 15.9452 42.0523L4.7137 57.0486ZM13.9882 47.906L13.9985 47.8968L13.9882 47.906ZM14.6439 47.906L14.6336 47.8968L14.6439 47.906Z",
    stroke: "url(#paint9_linear_6663_26985)",
    strokeWidth: 1.90855,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8903 42.4794L22.8903 42.4794L23.1944 42.1409C23.4305 41.8781 23.7086 41.6563 24.0173 41.4845C24.4923 41.2201 25.027 41.0814 25.5707 41.0814H33.4685C34.0485 41.0814 34.6239 41.1847 35.1678 41.3864L35.3976 41.4717C35.7216 41.5919 36.027 41.7575 36.3046 41.9635L35.7393 42.7252L36.3046 41.9635L36.4296 42.0562L22.8903 42.4794ZM22.8903 42.4794C22.6626 42.7328 22.4599 43.0076 22.2848 43.2998L22.1433 43.5361C21.742 44.2061 21.5301 44.9723 21.5301 45.7532V56.2503C21.5301 56.8827 22.0428 57.3954 22.6752 57.3954H24.381C24.701 57.3954 24.9903 57.2641 25.1981 57.0525M22.8903 42.4794L25.1981 57.0525M25.1981 57.0525C25.4059 57.2641 25.6952 57.3954 26.0152 57.3954H33.9833C34.3033 57.3954 34.5926 57.2641 34.8004 57.0525C35.0082 57.2641 35.2975 57.3954 35.6175 57.3954H37.411C37.995 57.3954 38.4684 56.922 38.4684 56.338V46.3073C38.4684 45.5009 38.2976 44.7037 37.9671 43.9681C37.6265 43.2098 37.0971 42.5516 36.4296 42.0563L25.1981 57.0525ZM34.4726 47.9099L34.4829 47.9007L34.4726 47.9099ZM35.1282 47.9099L35.1179 47.9007L35.1282 47.9099Z",
    stroke: "url(#paint10_linear_6663_26985)",
    strokeWidth: 1.90855,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3766 42.4794L43.3766 42.4794L43.6807 42.1409C43.9168 41.8781 44.1949 41.6563 44.5036 41.4845C44.9787 41.2201 45.5134 41.0814 46.0571 41.0814H53.9548C54.5348 41.0814 55.1103 41.1847 55.6541 41.3864L55.8839 41.4717C56.2079 41.5919 56.5133 41.7575 56.7909 41.9635L56.2256 42.7252L56.7909 41.9635L56.9159 42.0562L43.3766 42.4794ZM43.3766 42.4794C43.1489 42.7328 42.9462 43.0076 42.7711 43.2998L42.6296 43.5361C42.2283 44.2061 42.0164 44.9723 42.0164 45.7532V56.2503C42.0164 56.8827 42.5291 57.3954 43.1616 57.3954H44.8673C45.1873 57.3954 45.4766 57.2641 45.6844 57.0525M43.3766 42.4794L45.6844 57.0525M45.6844 57.0525C45.8922 57.2641 46.1815 57.3954 46.5015 57.3954H54.4697C54.7896 57.3954 55.079 57.2641 55.2867 57.0525C55.4945 57.2641 55.7839 57.3954 56.1038 57.3954H57.8973C58.4813 57.3954 58.9547 56.922 58.9547 56.338V46.3073C58.9547 45.5009 58.7839 44.7037 58.4534 43.9681C58.1128 43.2098 57.5835 42.5516 56.9159 42.0563L45.6844 57.0525ZM54.9589 47.9099L54.9692 47.9007L54.9589 47.9099ZM55.6146 47.9099L55.6043 47.9007L55.6146 47.9099Z",
    stroke: "url(#paint11_linear_6663_26985)",
    strokeWidth: 1.90855,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6663_26985",
    x1: 5.86509,
    y1: 32.5239,
    x2: 13.3038,
    y2: 40.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6663_26985",
    x1: 15.662,
    y1: 32.5239,
    x2: 23.1007,
    y2: 40.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6663_26985",
    x1: 26.3514,
    y1: 32.5239,
    x2: 33.7901,
    y2: 40.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6663_26985",
    x1: 36.1483,
    y1: 32.5239,
    x2: 43.587,
    y2: 40.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6663_26985",
    x1: 46.8358,
    y1: 32.5239,
    x2: 54.2745,
    y2: 40.9918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6663_26985",
    x1: 16.368,
    y1: 3.17125,
    x2: 41.1638,
    y2: 31.3975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6663_26985",
    x1: 22.1317,
    y1: 9.74133,
    x2: 35.3561,
    y2: 24.7953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6663_26985",
    x1: 26.2506,
    y1: 14.0099,
    x2: 31.2097,
    y2: 19.6552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6663_26985",
    x1: 28.0961,
    y1: 2.59965,
    x2: 42.008,
    y2: 16.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6663_26985",
    x1: 2.56735,
    y1: 41.6439,
    x2: 15.8509,
    y2: 57.4205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6663_26985",
    x1: 23.0517,
    y1: 41.6478,
    x2: 36.3353,
    y2: 57.4244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6663_26985",
    x1: 43.5381,
    y1: 41.6478,
    x2: 56.8216,
    y2: 57.4244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyndricon3);
export default __webpack_public_path__ + "static/media/fyndricon3.4a569d4a87d4d37f079234838a60d9c7.svg";
export { ForwardRef as ReactComponent };